import React, { useEffect, useState } from 'react';
import Main from 'layouts/Main';
import Container from 'components/Container';
import GenericContent from './components/GenericContent';
import Hero from './components/Hero';
import GlobalSearchBar from 'components/GlobalSearchBar';
import ContactLanding from '../Landing/components/ContactLanding/ContactLanding';
import SEO from 'components/SEO';
import config from 'config/config';
import { MainPageData } from './cmsTypes';

const MainPage = () => {
  const [main, setMain] = useState<MainPageData | null>(null);

  useEffect(() => {
    fetch(
      `${config.CMS_BASE_URL}/api/main-battery?populate[hero][populate][heroCarouselItems][populate]=*&populate[hero][populate]=background&populate[content][on][content.text-and-media][populate]=*&populate[content][on][content.carousel][populate][carouselItems][populate]=itemMedia&populate[content][on][content.certificates][populate]=certificates&populate[content][on][content.gallery][populate]=*&populate=SEO`,
    )
      .then((res) => res.json())
      .then((data) => {
        setMain(data?.data || null);
      })
      .catch((err) => {
        console.error('Failed to fetch hero component:', err);
        setMain(null);
      });
  }, []);

  const backgroundData = main?.hero?.background?.[0];
  let backgroundImage: string | undefined;

  if (backgroundData) {
    if (backgroundData.mime && backgroundData.mime.includes('svg')) {
      backgroundImage = backgroundData.url;
    } else {
      backgroundImage =
        backgroundData?.formats?.large?.url || backgroundData.url;
    }
  }

  const backgroundUrl = backgroundImage
    ? `${config.CMS_BASE_URL}${backgroundImage}`
    : '';

  return (
    <Main>
      {main && (
        <SEO
          title={main?.SEO?.MetaTitle}
          description={main?.SEO?.MetaDescription}
          keywords={main?.SEO?.MetaKeywords}
          url="/"
        />
      )}
      <Hero
        backgroundUrl={backgroundUrl}
        items={main?.hero?.heroCarouselItems}
      />
      <GlobalSearchBar />
      <GenericContent content={main?.content} />
      <Container
        id="contact-section"
        sx={{
          '@media (min-width: 900px)': {
            paddingBottom: '150px',
          },
        }}
      >
        <ContactLanding />
      </Container>
    </Main>
  );
};

export default MainPage;
